import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Material } from './material';
import { AddToCartUsecase } from './usecase/add-to-cart-usecase';
import { AddToCartUsecaseRequest } from './usecase/add-to-cart-usecase-request';
import { CalculateTotalPriceUsecase } from './usecase/calculate-total-price-usecase';
import { RemoveMaterialUsecase } from './usecase/remove-item-usecase';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShoppingcartPopupComponent } from './shoppingcart-popup/shoppingcart-popup.component';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Order } from './order';
import { AnswerToCreateOrderRequest } from './answer-to-create-order-request';
import { CreateOrderRequest } from './createorderrequest';
import { Package } from './package';
import { GoogleTagManagerService } from '../google-tag-manager/google-tag-manager.service';
import { DataDialog } from '../login/verification/dataDialog';
import { SigninComponent } from '../login/signin/signin.component';
import { BehaviorSubject } from 'rxjs';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../toastmessage/toastmessage.service';
import { CookieObject } from '../cookie/cookieobject';

@Injectable({
    providedIn: 'root'
})
export class ShoppingcartService {
    materials$: BehaviorSubject<Material[]>;

    materials: Material[] = [];

    createOrderRequest?: CreateOrderRequest = {};

    order?: Order = {};

    hasDelivery = false;

    isCompany = false;

    totalPrice: Subject<number> = new Subject<number>();

    totalQuantity: Subject<number> = new Subject<number>();

    isShoppingCartClicked = false;

    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';
    answerToCreateOrderRequest?: AnswerToCreateOrderRequest = {};
    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };

    dataDialog: DataDialog = {};

    message = 'Az előrendeléshez regisztráció, bejelentkezés szükséges!';

    isExtraSmall: Observable<BreakpointState>;

    hasToAuthenticatePreorder = 'Előrendeléshez kérjük jelentkezzen be fiókjába! ';
    constructor(
        private _matDialog: MatDialog,
        private _addToCartUsecase: AddToCartUsecase,
        private _calculatetotalPriceUsecase: CalculateTotalPriceUsecase,
        private _removeMaterialUseCase: RemoveMaterialUsecase,
        private readonly breakpointObserver: BreakpointObserver,
        private _googleTagManagerService: GoogleTagManagerService,
        private _toastMessageService: ToastmessageService
    ) {
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
        this.materials$ = new BehaviorSubject<Material[]>(this.materials);
    }

    private getMaterials() {
        if (sessionStorage.getItem('materials')) {
            this.setMaterials(JSON.parse(sessionStorage.getItem('materials') as string) as Material[]);
        }
    }

    private setMaterials(materials: Material[]) {
        this.materials$.next(materials);
    }

    addToCart(material: Material) {
        const webSiteCookieAccepted = JSON.parse(localStorage.getItem('websiteCookieAccepted') as string) as boolean;
        if (webSiteCookieAccepted) {

            if (sessionStorage.getItem('materials')) {
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                const request: AddToCartUsecaseRequest = { material: material, materials: materials };
                this._addToCartUsecase.execute(request);
            } else if (!sessionStorage.getItem('materials')) {
                //TODO somehow when session has been clear after order has been created, by rebuy a product the previous products reloads by addToCart()
                //TODO check where is the value of this.materials the previous!
                this.materials = [];
                const request: AddToCartUsecaseRequest = { material: material, materials: this.materials };
                this._addToCartUsecase.execute(request);
            }

            this.calculateTotalPrice();
            this.loadSelectedMaterial(material, this.enterAnimationDuration, this.exitAnimationDuration);

            this._googleTagManagerService.addtoCartProduct(material);

        }
        else {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Ön nem járult hozzá az oldalunkon lévő sütik használatához, ezért csak azok elfogadása után vásárolhat webshopunkban!', MAT_ICON.warning);
            this.dismissError();
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
            window.location.reload();
        }, 4000);
    }

    addToCartPackage(products: Material[], packagee: Package) {
        const webSiteCookieAccepted = JSON.parse(localStorage.getItem('websiteCookieAccepted') as string) as boolean;
        if (webSiteCookieAccepted) {

            if (sessionStorage.getItem('materials')) {
                const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                products.forEach((material) => {
                    const request: AddToCartUsecaseRequest = { material: material, materials: materials };
                    this._addToCartUsecase.execute(request);
                });

                this._googleTagManagerService.addtoCartPackage(products);
            } else if (!sessionStorage.getItem('materials')) {
                //TODO somehow when session has been clear after order has been created, by rebuy a product the previous products reloads by addToCart()
                //TODO check where is the value of this.materials the previous!
                this.materials = [];
                products.forEach((material) => {
                    const request: AddToCartUsecaseRequest = { material: material, materials: this.materials };
                    this._addToCartUsecase.execute(request);
                });

                this._googleTagManagerService.addtoCartPackage(products);

            }

            this.calculateTotalPrice();
            this.loadSelectedPackage(packagee, this.enterAnimationDuration, this.exitAnimationDuration);

            this._googleTagManagerService.addtoCartPackage(products);
        }
        else {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Ön nem járult hozzá az oldalunkon lévő sütik használatához, ezért csak azok elfogadása után vásárolhat webshopunkban!', MAT_ICON.warning);
            this.dismissError();
        }
    }

    getItems(): Material[] {
        if (sessionStorage.getItem('materials')) {
            this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
            return this.materials;
        } else {
            return this.materials;
        }
    }

    removeItem(material: Material) {
        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        const request = { material: material, materials: materials };
        this._removeMaterialUseCase.execute(request);
        this.calculateTotalPrice();
        if (!material.packageName) {
            this._googleTagManagerService.removeProductFromCart(material);
        }
    }

    clearCart() {
        this.materials = [];
        return this.materials;
    }

    calculateTotalPrice() {
        const totalPrice = JSON.parse(sessionStorage.getItem('totalPrice') as string) as number;
        const totalQuantity = JSON.parse(sessionStorage.getItem('totalQuantity') as string) as number;
        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        const request = {
            totalPrice: totalPrice,
            totalQuantity: totalQuantity,
            materials: materials
        };
        this._calculatetotalPriceUsecase.execute(request);
    }
    increaseItemQuantity(material: Material) {
        material.quantity!++;
        material.quantityOfSupply!++;
        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        materials.forEach((materialElement) => {
            if (materialElement.id === material.id && materialElement.packageName === material.packageName) {
                materialElement.quantity!++;
                materialElement.quantityOfSupply!++;
            }
        });
        sessionStorage.setItem('materials', JSON.stringify(materials));
        this.calculateTotalPrice();
    }

    decreaseItemQuantity(material: Material) {
        const materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
        if (material.quantity! > 0) {
            material.quantity!--;
            material.quantityOfSupply!--;

            if (material.quantity === 0) {
                this.removeItem(material);
                const index = materials.indexOf(material);
                materials.splice(index, 1);
                sessionStorage.setItem('materials', JSON.stringify(materials));
                this.calculateTotalPrice();
            } else {
                materials.forEach((materialElement) => {
                    if (materialElement.id === material.id && materialElement.packageName === material.packageName) {
                        materialElement.quantity!--;
                        materialElement.quantityOfSupply!--;
                    }
                });
                sessionStorage.setItem('materials', JSON.stringify(materials));
            }
            this.calculateTotalPrice();
        }
    }

    loadSelectedMaterial(selectedMaterial: Material, enterAnimationDuration: string, exitAnimationDuration: string) {
        this.dialogConfiger.data = selectedMaterial;
        const popupDialog = this._matDialog.open(ShoppingcartPopupComponent, {
            data: selectedMaterial,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw'
        });
        const smallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '70vh');
            } else {
                popupDialog.updateSize('calc(50% - 50px)', '');
            }
        });
        popupDialog.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
        });
    }

    loadSelectedPackage(selectedPackage: Package, enterAnimationDuration: string, exitAnimationDuration: string) {
        this.dialogConfiger.data = selectedPackage;
        const popupDialog = this._matDialog.open(ShoppingcartPopupComponent, {
            data: selectedPackage,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw'
        });
        const smallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '70vh');
            } else {
                popupDialog.updateSize('calc(50% - 50px)', '');
            }
        });
        popupDialog.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
        });
    }

    openLogin(material: Material) {
        this.dataDialog = {
            message: this.message,
            material: material
        };
        const popupDialog = this._matDialog.open(SigninComponent, {
            data: this.dataDialog,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }
}
